import { INTERACTIVE_OBJECT_TYPE_ID } from '../constants/properties';
import { OBJECT_SUMMARY } from 'copilot-toolkit/constants/CopilotInAppActionTypes';
const WEB_INTERACTIVE_OBJECT_TYPE_LABEL = 'webInteractive';
export const createWebInteractiveCopilotAction = ({
  objectId,
  label
}) => {
  const action = {
    intent: OBJECT_SUMMARY,
    objectId,
    objectTypeId: INTERACTIVE_OBJECT_TYPE_ID,
    objectTypeLabel: WEB_INTERACTIVE_OBJECT_TYPE_LABEL,
    summaryType: 'WEB_INTERACTIVE'
  };
  if (label) {
    action.label = label;
  }
  return action;
};